import { render, staticRenderFns } from "./dropdown-checkbox.vue?vue&type=template&id=0f5847e4&scoped=true"
import script from "./dropdown-checkbox.vue?vue&type=script&lang=js"
export * from "./dropdown-checkbox.vue?vue&type=script&lang=js"
import style0 from "./dropdown-checkbox.vue?vue&type=style&index=0&id=0f5847e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5847e4",
  null
  
)

export default component.exports